import type { FranchiseStats, FranchiseTenant, TenantSettings } from './types';

export const MOCK_TENANT_SETTINGS: TenantSettings = {
  id: 'tenant-001',
  name: 'KGC Budapest - Keleti',
  legalName: 'Kisgépcentrum Budapest Kft.',
  taxNumber: '12345678-2-42',
  registrationNumber: '01-09-123456',
  bankAccount: 'HU42 1234 5678 9012 3456 7890 1234',
  bankName: 'OTP Bank',

  address: 'Kerepesi út 52.',
  city: 'Budapest',
  postalCode: '1087',
  country: 'Magyarország',
  phone: '+36 1 234 5678',
  email: 'budapest.keleti@kgc.hu',
  website: 'https://kgc.hu/budapest-keleti',

  businessHours: {
    monday: { open: '08:00', close: '18:00', closed: false },
    tuesday: { open: '08:00', close: '18:00', closed: false },
    wednesday: { open: '08:00', close: '18:00', closed: false },
    thursday: { open: '08:00', close: '18:00', closed: false },
    friday: { open: '08:00', close: '18:00', closed: false },
    saturday: { open: '08:00', close: '13:00', closed: false },
    sunday: { open: '', close: '', closed: true },
  },

  primaryColor: '#1e3a5f',
  accentColor: '#f59e0b',

  currency: 'HUF',
  timezone: 'Europe/Budapest',
  language: 'hu',
  vatRate: 27,

  createdAt: '2020-01-15T08:00:00Z',
  updatedAt: '2024-01-18T10:30:00Z',
};

export const MOCK_FRANCHISE_TENANTS: FranchiseTenant[] = [
  {
    id: 'tenant-001',
    name: 'KGC Budapest - Keleti',
    city: 'Budapest',
    status: 'active',
    ownerName: 'Nagy Péter',
    ownerEmail: 'nagy.peter@kgc.hu',
    employeeCount: 8,
    monthlyRevenue: 4250000,
    activeRentals: 45,
    activeWorksheets: 12,
    lastActivityAt: '2024-01-18T14:30:00Z',
    createdAt: '2020-01-15T08:00:00Z',
  },
  {
    id: 'tenant-002',
    name: 'KGC Budapest - Nyugati',
    city: 'Budapest',
    status: 'active',
    ownerName: 'Szabó Anna',
    ownerEmail: 'szabo.anna@kgc.hu',
    employeeCount: 6,
    monthlyRevenue: 3180000,
    activeRentals: 32,
    activeWorksheets: 8,
    lastActivityAt: '2024-01-18T13:15:00Z',
    createdAt: '2021-03-20T08:00:00Z',
  },
  {
    id: 'tenant-003',
    name: 'KGC Debrecen',
    city: 'Debrecen',
    status: 'active',
    ownerName: 'Kovács József',
    ownerEmail: 'kovacs.jozsef@kgc.hu',
    employeeCount: 5,
    monthlyRevenue: 2850000,
    activeRentals: 28,
    activeWorksheets: 6,
    lastActivityAt: '2024-01-18T11:45:00Z',
    createdAt: '2021-06-10T08:00:00Z',
  },
  {
    id: 'tenant-004',
    name: 'KGC Szeged',
    city: 'Szeged',
    status: 'active',
    ownerName: 'Tóth Gábor',
    ownerEmail: 'toth.gabor@kgc.hu',
    employeeCount: 4,
    monthlyRevenue: 2100000,
    activeRentals: 22,
    activeWorksheets: 5,
    lastActivityAt: '2024-01-18T10:30:00Z',
    createdAt: '2022-01-05T08:00:00Z',
  },
  {
    id: 'tenant-005',
    name: 'KGC Győr',
    city: 'Győr',
    status: 'inactive',
    ownerName: 'Horváth Miklós',
    ownerEmail: 'horvath.miklos@kgc.hu',
    employeeCount: 3,
    monthlyRevenue: 0,
    activeRentals: 0,
    activeWorksheets: 0,
    lastActivityAt: '2024-01-10T16:00:00Z',
    createdAt: '2022-09-15T08:00:00Z',
  },
  {
    id: 'tenant-006',
    name: 'KGC Pécs',
    city: 'Pécs',
    status: 'active',
    ownerName: 'Kiss László',
    ownerEmail: 'kiss.laszlo@kgc.hu',
    employeeCount: 4,
    monthlyRevenue: 1950000,
    activeRentals: 18,
    activeWorksheets: 4,
    lastActivityAt: '2024-01-18T09:00:00Z',
    createdAt: '2023-02-01T08:00:00Z',
  },
];

export const MOCK_FRANCHISE_STATS: FranchiseStats = {
  totalTenants: 6,
  activeTenants: 5,
  totalRevenue: 14330000,
  totalEmployees: 30,
  totalRentals: 145,
  totalWorksheets: 35,
};

export const DAY_LABELS: Record<string, string> = {
  monday: 'Hétfő',
  tuesday: 'Kedd',
  wednesday: 'Szerda',
  thursday: 'Csütörtök',
  friday: 'Péntek',
  saturday: 'Szombat',
  sunday: 'Vasárnap',
};
